import { modalAtom } from '@store/atoms'
import ModalRoot from '@ui/components/ModalRoot'
import { MobileBootFromQR } from '@ui/richiesta/MobileBootQR'
import { MobileSwitchPage } from '@ui/richiesta/pages/mobile-switch/mobile-switch.page'
import ThankYou from '@ui/richiesta/pages/thank-you/thank-you.page'
import { useAtom } from 'jotai'
import React, { Suspense } from 'react'
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom'

import loaderImg from '@assets/loader_200_trasp.gif'
import { ThankYouSimulatore } from '@ui/simulatore/ThankYou'
import { Analytics } from '@ui/components/analytics'
import MobileMissingDocumentsUploadPage from '@ui/richiesta/MobileMissingDocumentsUploadPage'
import {SatelliteTracker } from '@ui/components/analyticsSatellite/SatelliteTracker'

const Simulatore = React.lazy(() => import('@ui/simulatore/Simulatore'))
const PageRichiesta = React.lazy(() => import('@ui/richiesta/PageRichiesta'))

const Home = () => {
	return <h1>Home Crediper</h1>
}

export const AppLoader = () => (
	<div className='flex items-center justify-center h-screen'>
		<img
			src={loaderImg}
			alt='loader'
			className='w-[120px] h-[120px] animate-spin'
		/>
	</div>
)

function App() {
	console.log("VERSIONE TEST YUP")
	const [modal, setModal] = useAtom(modalAtom)

	const closeModal = () => setModal({ ...modal, isOpen: false })
	return (
		<Router basename='/preventivatore'>
			<Analytics />
		 <SatelliteTracker />
			<Suspense fallback={<AppLoader />}>
				<Routes>
					<Route path='/' element={<Home />} />

					<Route
						path='Home/MobileUpload/:token'
						element={<MobileBootFromQR />}
					/>
					<Route
						path='Home/MobileMissingDocumentsUpload/:token'
						element={<MobileMissingDocumentsUploadPage />}
					/>
					<Route path='Home/MobileSwitch' element={<MobileSwitchPage />} />
					<Route path='Home/ThankYou' element={<ThankYou />} />
					<Route path='thankyou' element={<ThankYouSimulatore />} />
					

					<Route path='simulatore/*' element={<Simulatore />} />
					<Route path='richiesta/*' element={<PageRichiesta />} />

					<Route path='*' element={<Navigate to='/' />} />
				</Routes>
			</Suspense>

			<ModalRoot
				isOpen={modal.isOpen}
				onCloseModal={closeModal}
				title={modal.title || ''}
				onCallBack={modal.onCallBack || (() => {})}
				labelOk={modal.labelOk || null}
				labelClose={modal.labelClose || null}
				disableButton={modal.disableButton || false}
			>
				{modal.children}
			</ModalRoot>
		</Router>
	)
}

export default App
